import { GLTFLoader } from "../threehelpers/GLTFloader";

import { defineQuery, enterQuery } from "bitecs";
import { World } from "../threeMain";
import { RPMAvatar } from "../utils/components";
import qs from "query-string"
import { setObject3dComponent } from "./bit-object-system";
import { Box3, Camera, Euler, Matrix4, Mesh, Object3D, Quaternion, SkinnedMesh } from "three";

import { video } from "../App";
import { smoothenVal } from "../utils/smoothValue";
import { Category } from "@mediapipe/tasks-vision";


const rpmQuery = defineQuery([RPMAvatar])
const rpmEntry = enterQuery(rpmQuery);

interface AvatarData {
  head?: Object3D,
  teeth?: Object3D,
  beard?: Object3D,
  avatar?: Object3D,
  customHead?: Object3D,
  root?: Object3D,
  meshes: Object3D[],
  loaded: boolean,
  mirror: boolean,
}
let avatarDataMap : Map<number, AvatarData> = new Map()

export function rpmSystem(world: World){
  rpmQuery(world).forEach(async (eid: number) => {
    const avatarData = avatarDataMap.get(eid) || {
      loaded: false,
      meshes: [],
      mirror: true,
    }
    if(!avatarDataMap.get(eid)) avatarDataMap.set(eid, avatarData);
    if(avatarData.loaded) return
    const queryData = qs.parseUrl(window.location.href, {parseFragmentIdentifier: true}).query;
    const glbId = queryData?.modelId || "";
    const mirror = queryData?.mirror !== undefined;
    avatarData.mirror = mirror;
    if(!glbId) return;
    const loader = new GLTFLoader()
    const url = `https://models.readyplayer.me/${glbId}.glb?lod=0&textureAtlas=none&morphTargets=ARKit`
    avatarData.loaded = true
    loader.load(url, ( gltf: any ) => {
      const camera = window.APP!.camera!
      const avatar = gltf.scenes[0];
      const box = new Box3().setFromObject(avatar);
      const height = box.max.y - box.min.y
      camera.position.y += 0.05;
      if(height < 1.8){
        camera.position.y -= 0.0995;
      }
      console.log("### box", box, height);

      avatarData.root = avatar;

      avatarData.head = avatar.getObjectByName("Wolf3D_Head")
      avatarData.teeth = avatar.getObjectByName("Wolf3D_Teeth")
      avatarData.beard = avatar.getObjectByName("Wolf3D_Beard")
      avatarData.avatar = avatar.getObjectByName("Wolf3D_Avatar")
      avatarData.customHead = avatar.getObjectByName("Wolf3D_Head_Custom")
      avatar.traverse(( mesh: any ) => {
        if(mesh.isSkinnedMesh) avatarData.meshes.push(mesh)
      })
      // avatarData.meshes.push(avatarData.head!)
      // avatarData.meshes.push(avatarData.teeth!)
      // avatarData.meshes.push(avatarData.beard!)
      // avatarData.meshes.push(avatarData.avatar!)
      // avatarData.meshes.push(avatarData.customHead!)
      avatarData.meshes = avatarData.meshes.filter(Boolean);
      ( window as any ).avatarData = avatarData

      avatar.traverse((m : any) => {
        m.castShadow = true;
        m.receiveShadow = true;
      })
      world.scene.add(avatar);
      setObject3dComponent(world, eid, avatar);
      ( window as any ).avatar = avatar
      // window.APP!.light.target.add(avatar)
    })
    // setObject3dComponent(world, eid, cube);
  })
  

  const predictor = window.APP!.mediaPipePredictor!;
  if(!predictor.running) predictor.run();
  rpmQuery(world).forEach(async (eid: number) => {
    const avatarData = avatarDataMap.get(eid); 
    if(!avatarData) return;
    if (predictor.blendshapes.length > 0) {
      predictor.blendshapes.forEach(element => {
        avatarData.meshes.forEach(( mesh: Object3D ) => {
          const el = filterBlendShapes(element, avatarData.mirror);
          const skinnedMesh = mesh as SkinnedMesh;
          let index = skinnedMesh?.morphTargetDictionary?.[el.categoryName];
          if (index! >= 0) {
            const current = ( skinnedMesh as any ).morphTargetInfluences[index!] as number;
            ( skinnedMesh as any ).morphTargetInfluences[index!] = el.score
          }
        });
      });

      const root = avatarData.root;
      const rotation = predictor.rotation;

      let mul = avatarData.mirror ? -1 : 1
      smoothenEuler(root?.getObjectByName("Head")?.rotation, rotation.x - 0.5, mul * rotation.y, mul * rotation.z-0.03);
      smoothenEuler(root?.getObjectByName("Neck")?.rotation, rotation.x / 5 + 0.3, mul* rotation.y / 5, mul * rotation.z / 5);
      smoothenEuler(root?.getObjectByName("Spine2")?.rotation, rotation.x / 10, mul* rotation.y / 10, mul * rotation.z / 10);
    }
  })
}

function smoothenEuler(rot: Euler | undefined, x: number, y: number, z: number){
  if(!rot) return;
  const slerpVal = 0.75
  // const slerpVal = 0.07
  const newX = rot.x + (x - rot.x) * slerpVal;
  const newY = rot.y + (y - rot.y) * slerpVal;
  const newZ = rot.z + (z - rot.z) * slerpVal;

  rot.set(newX, newY, newZ)
}

function filterBlendShapes(blendShape: Category, mirror: boolean): Category{
  let newBlendShape = {...blendShape};
  switch (blendShape.categoryName) {
    case "mouthSmileLeft":
    case "mouthSmileRight":
      newBlendShape.score = Math.min(0.45, blendShape.score)  
    break;

    case "mouthUpperUpLeft":
    case "mouthUpperUpRight":
      newBlendShape.score = Math.min(0.25, blendShape.score)  
    break;
  }
  if(mirror){
    if(blendShape.categoryName.includes("Left")){
      newBlendShape.categoryName = blendShape.categoryName.replace("Left", "Right")
    } else if(blendShape.categoryName.includes("Right")){
      newBlendShape.categoryName = blendShape.categoryName.replace("Right", "Left")
    }
  }
  return newBlendShape;
}